import BaseUseCase from "../../../base_use_case.js";

class SavePageUseCase extends BaseUseCase {

  execute(identifier, params) {
    let url = identifier ? `/api/v1/admin/frontend/pages/${identifier}` : `/api/v1/admin/frontend/pages`;

    let wrappedParams = this.wrapParams(params, "page");
    wrappedParams.findBySlug = true;

    return this.httpClient({
      ...this.requestConfig(),
      method: identifier ? "put" : "post",
      url: url,
      data: wrappedParams,
    });
  }
}

const instance = new SavePageUseCase();
export default instance;